define('util/bindingHandlerUtils',[
    'lib/lodash4',
    'bindingHandlers/include'
], function(
    _,
    include
) {
    'use strict';

    /**
     * (Public) Gets the component context from the context parents
     *
     * @param   bindingContext (object) The binding context of the handler making
     *                                  the call
     *
     * @return                 (string) The component name or undefined if it is
     *                                  not in the context of a component
     **/
    var getContext = function(bindingContext) {
        var context;
        if (bindingContext) {
            _.each(bindingContext.$parents, function (parent) {
                if (parent) {
                    var templateContext = parent[include.TEMPLATE_CONTEXT_KEY];
                    if (templateContext) {
                        context = templateContext;
                    }
                }
            });
        }
        return context;
    };

    /**
     * (Public) Determines if the template should be loaded in the context of a
     * component, and if so, appends the template context key to the viewModel.
     *
     * @param   viewModel      (object) The viewModel that will be passed into the
     *                                  include binding
     * @param   bindingContext (object) The binding context of the handler making
     *                                  the call
     *
     * @return                 (object) viewModel, either original or with a template
     *                                  context key appended
     **/
    var decorateWithTemplateContext = function(viewModel, bindingContext) {
        var context = getContext(bindingContext);

        if (context) {
            viewModel[include.TEMPLATE_CONTEXT_KEY] = context;
        }
        return viewModel;
    };

    /**
     * (Public) Checks the component context and adjusts the template name so it
     * can be loaded properly
     *
     * @param   templateName   (string) The template string
     *
     * @param   bindingContext (object) The binding context of the handler making
     *                                  the call
     *
     * @return                 (object) The template name in the format needed
     *                                  in order for it to be properly loaded.
     **/
    var adjustTemplateNameForContext = function(templateName, bindingContext) {
        var context = getContext(bindingContext);

        if (templateName && context) {
            var componentRegex = new RegExp('^' + context + '/');
            templateName = templateName.replace(componentRegex, 'components/' + context + '/templates/');
            templateName = templateName.replace(/^core\//, 'templates/');
            if (templateName == 'main') {
                templateName = 'components/' + context + '/templates/main';
            }
        }
        return templateName;
    };

    return {
        getContext: getContext,
        decorateWithTemplateContext: decorateWithTemplateContext,
        adjustTemplateNameForContext: adjustTemplateNameForContext
    };

});

